import { Modal } from 'antd';
import React from 'react';
import { UserStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { UsuarioCardAlta } from './UsuarioCardAlta';

interface ModalUsuarioProps {
    userStore?: UserStore;
}

const ContainerModal = styled(Modal)`
    min-width: 750px;
    .ant-modal-body {
        padding: unset;
    }
`;

@inject('userStore')
@observer
export class ModalUsuario extends React.Component<ModalUsuarioProps> {
    render() {
        const { userStore } = this.props;
        return (
            <>
                <ContainerModal
                    centered={true}
                    visible={userStore!.openModal}
                    footer={null}
                    closable={false}
                    maskClosable={false}
                >
                    <UsuarioCardAlta />
                </ContainerModal>
            </>
        );
    }
}
